<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <!-- HEADER -->
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
          >
            <h4 class="position-relative text-black fw-bold mb-10">
              Informations générales
            </h4>
            <router-link
              to="/liste-professeurs"
              class="btn btn-primary transition border-0 lh-1 fw-medium"
            >
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              Retour
            </router-link>
          </div>

          <!-- INFORMATIONS GENERALES -->
          <table class="table">
            <tbody>
              <tr v-if="professeur?.nom">
                <td>Nom :</td>
                <td>{{ professeur.nom }}</td>
              </tr>
              <tr v-if="professeur?.prenom">
                <td>Prénom :</td>
                <td>{{ professeur.prenom }}</td>
              </tr>
              <tr v-if="professeur?.adresse">
                <td>Adresse :</td>
                <td>{{ professeur.adresse }}</td>
              </tr>
              <tr v-if="professeur?.email">
                <td>Email :</td>
                <td>{{ professeur.email }}</td>
              </tr>
              <tr v-if="professeur?.telProfesseur1">
                <td>Téléphone 1 :</td>
                <td>{{ professeur.telProfesseur1 }}</td>
              </tr>
              <tr v-if="professeur?.telProfesseur2">
                <td>Téléphone 2 :</td>
                <td>{{ professeur.telProfesseur2 }}</td>
              </tr>
              <tr v-if="professeur?.npi">
                <td>Numéro NPI :</td>
                <td>{{ professeur.npi }}</td>
              </tr>
              <tr v-if="professeur?.ifu">
                <td>IFU :</td>
                <td>{{ professeur.ifu }}</td>
              </tr>
              <tr v-if="professeur?.dateNaissance">
                <td>Date de naissance :</td>
                <td>{{ format_Date(professeur.dateNaissance) }}</td>
              </tr>
            </tbody>
          </table>

          <!-- MATIERES ENSEIGNEES -->
          <div v-if="professeur?.matieres?.length" class="mt-4">
            <h5 class="text-center mb-3">Matières enseignées par ce professeur</h5>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Libellé</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(matiere, index) in professeur.matieres" :key="index">
                  <td>{{ matiere.libelle }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- ACTIVITES -->
          <div v-if="professeur?.activites?.length" class="mt-4">
            <h5 class="text-center mb-3">Activités</h5>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Libellé</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(activite, index) in professeur.activites" :key="index">
                  <td>{{ activite.libelle }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- PIECES JOINTES -->
          <div v-if="professeur?.pieces?.length" class="mt-4">
            <h5 class="text-center mb-3">Pièces jointes</h5>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Numéro</th>
                  <th>Document</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(piece, index) in professeur.pieces" :key="index">
                  <td>{{ piece.typePiece?.libelle }}</td>
                  <td>{{ piece.numeroPiece }}</td>
                  <td>
                    <a
                      :href="piece.urlImage"
                      target="_blank"
                      class="btn btn-sm btn-outline-primary"
                    >
                      Télécharger
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewProfesseur",
  setup() {
    const route = useRoute();
    const professeur = ref<any>(null);

    // 🔹 Chargement du professeur
    const getProfesseur = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/professeurs/${id}`);
        professeur.value = data.data;
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement du professeur.");
      }
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) getProfesseur(id);
    });

    return {
      professeur,
      format_Date,
    };
  },
});
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
